import React from 'react';
const ProductImageButton = (props) => {
    return (React.createElement("button", { className: "product-image-button", "aria-haspopup": "dialog", onClick: (e) => {
            const eTarget = e.target;
            const shouldClick = !eTarget.classList.contains('product-video-pause');
            //Prevent opening the zoom image when play/pause video
            if (shouldClick) {
                props.onImageClick();
            }
        }, "aria-label": props.ariaLabel }, props.children));
};
export default ProductImageButton;
